module.exports = __webpack_public_path__ + "img/attribute2.d003b9a6.png";